<template>
  <FormulateForm
    :name="parameter.value"
    @submit="submit"
    class="bg-gray-100 py-4 px-6 mb-8"
  >
    <div class="flex">
      <div class="w-1/2">
        <FormulateInput
          v-model="name"
          name="name"
          type="text"
          label="Name"
          placeholder="Name"
          validation="required"
        />
      </div>
      <div class="w-1/2 pl-8">
        <div v-if="fetchingItems" class="text-blue-400">
          <base-loading class="block text-3xl" />
          Loading items
        </div>
        <div v-else>
          <div class="flex justify-between items-center">
            <label class="formulate-input-label">
              Options
            </label>
            <base-search-input v-model="itemsSearchTerm" class="w-48 mb-2" />
          </div>

          <base-notice v-if="visibleItems.length > 20">
            There are <b>{{ visibleItems.length }}</b> items on the list. Please
            use the search field to shrink down the results.
          </base-notice>

          <base-notice v-else-if="visibleItems.length === 0">
            No matching items found.
          </base-notice>

          <div v-else class="formulate-input-grouping">
            <div
              v-for="(item, index) in visibleItems"
              :key="index"
              class="formulate-group"
            >
              <div class="flex mb-2">
                <div class="flex-1 bg-white py-2 px-3">
                  {{ item.value }}
                </div>
                <div class="h-10">
                  <base-button
                    @click="toggleValueAdvancedForm(item.index)"
                    type="button"
                    class="h-full"
                  >
                    <icon-close
                      title="Close"
                      v-if="openAdvancedOptions.includes(item.index)"
                    />
                    <icon-cog title="Advanced" v-else />
                  </base-button>
                </div>
              </div>
              <div
                v-if="openAdvancedOptions.includes(item.index)"
                class="px-3 py-2 bg-gray-200 mb-4"
              >
                <div class="mb-4">
                  <FormulateInput
                    :value="item.prefix"
                    @input="(event) => updateValue(event, item.index, 'prefix')"
                    name="prefix"
                    type="text"
                    help="If this option was selected the prefix will be used in the final tracking link"
                    label="Tracking link prefix"
                  />
                </div>
                <FormulateInput
                  :value="item.tracking_param"
                  @input="
                    (event) => updateValue(event, item.index, 'tracking_param')
                  "
                  name="tracking_param"
                  type="text"
                  help="If this option was selected the tracking parameter will be used for the final tracking link"
                  label="Tracking parameter"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <base-button type="submit" class="mt-6" :loading="saving">
      Save
    </base-button>
  </FormulateForm>
</template>

<script>
export default {
  props: {
    parameter: Object,
  },
  data() {
    return {
      formName: 'marketerDataForm',
      name: this.parameter.value,
      items: [],
      itemsSearchTerm: '',
      fetchingItems: true,
      saving: false,
      openAdvancedOptions: [],
    };
  },
  computed: {
    visibleItems() {
      return this.items.filter(({ value }) =>
        value.toLowerCase().includes(this.itemsSearchTerm.toLowerCase())
      );
    },
  },
  created() {
    this.fetchItems();
  },
  methods: {
    updateValue(value, index, name) {
      this.items[index][name] = value;
    },
    toggleValueAdvancedForm(index) {
      if (this.openAdvancedOptions.includes(index)) {
        this.openAdvancedOptions = this.openAdvancedOptions.filter(
          (i) => i !== index
        );
      } else {
        this.openAdvancedOptions.push(index);
      }
    },
    async fetchItems() {
      this.fetchingItems = true;
      const { data } = await this.$api.get(
        `partial_marketer_mapping/?include_${this.parameter.name}=true`
      );
      this.items = data.map((obj, index) => ({
        value: obj[this.parameter.name],
        prefix: '',
        tracking_param: '',
        index,
      }));
      this.fetchingItems = false;
    },
    async submit() {
      // todo add company prefix creation
      console.log(this.items);
      this.saving = true;
      await this.$store.dispatch('company/updateParameterName', this.name);
      this.saving = false;
      this.$emit('saved');
    },
  },
};
</script>
